import { number } from 'yargs'

export enum ClientServiceErrorCode {
  GENERAL,
}

export interface ClientFailure {
  message: string
}

export enum ClientViewPage {
  Base = 'base',
  Edit = 'bedit',
  Loans = 'loans',
  ParallelLoans = 'paraloans',
  RelatedLoans = 'relatedloans',
  Delegates = 'delegates',
  ActiveNotes = 'activenotes',
  LinkedFiles = 'linkedfiles',
  Rating = 'rating',
  LoanStats = 'loanstats',
  DynamicFields = 'custfields',
  IdDocs = 'iddocs',
  CashDocs = 'cashdocs',
  DelegateCashDocs = 'delegatecashdocs',
  Accounts = 'accounts',
  notjson = 'notjson',
  notjson_2 = 'notjson2',
  AddTag = 'tagadd',
  TagDelete = 'tagdelete',
  Printclientdetails = 'printclientdetails',
}

export interface ClientLoanStatsServerData {
  IsActiveCNT: number
  IsDueCNT: number
  IsOverdueCNT: number
}

export enum ClientNotesPage {
  Add = 'noteadd',
  Edit = 'noteedit',
  Delete = 'notedelete',
}

export interface ClientNoteAddEditAttributes {
  ID?: number
  ClientID: number
  HashSum_ClientID_: string
  Comment: string
  TypeID: number
  Active: number
  OperDate: string
  FileID: number
  HashSum_FileID_: string
}

export interface ClientNoteDeleteAttributes {
  ID: number
  ClientID: number
  HashSum_ClientID_: string
}

export enum ClientMonitoringsPage {
  Add = 'monitoringadd',
  Edit = 'monitoringedit',
  Delete = 'monitoringdelete',
}

export interface ClientMonitoringAddEditAttributes {
  ID?: number
  HashSum_ClientMonID_?: string
  ClientID: number
  HashSum_ClientID_: string
  SDate: string
  TypeID: number
  Criterium1: string
  Criterium2: string
  Criterium3: string
  Criterium4: string
  Criterium5: string
  Criterium6: string
  Comment: string
  FileID: number
  HashSum_FileID_: string
  LFLID: number
}

export interface ClientMonitoringDeleteAttributes {
  ID: number
  HashSum_ClientMonID_: string
  ClientID: number
  HashSum_ClientID_: string
}

export enum ClientRiskLevelsPage {
  Add = 'riskleveladd',
  Delete = 'riskleveldelete',
}

export interface ClientRiskLevelAddAttributes {
  ClientID: number
  HashSum_ClientID_: string
  KYCValidityID: number
  AMLStatusID: number
  AMLSuspiciousID: number
  AMLIndustryID: number
  PEPFlag: number
  OperDate: string
  FileID: number
  Comment: string
  Comment2: string
  Comment_FMS: string
  HashSum_FileID_: string
}

export interface ClientRiskLevelDeleteAttributes {
  ClientID: number
  HashSum_ClientID_: string
  ID: number
}

export enum ClientDelegatesPage {
  Add = 'delegateadd',
  Edit = 'delegateedit',
  Delete = 'delegatedelete',
}

export interface ClientDelegateAddEditAttributes {
  ID?: number
  HashSum_DelegateID_?: string
  ClientID: number
  HashSum_ClientID_: string
  Comment?: string
  Active: number
  OperDate: string
  StartDate: string
  EndDate: string | null
  Share?: string
  RLClientID: number
  HashSum_RLClientID_: string
  FileID?: number
  HashSum_FileID_?: string
  RLTypeID: number
  CashOper: number
}

export interface ClientDelegateDeleteAttributes {
  ID: number
  HashSum_DelegateID_: string
  ClientID: number
  HashSum_ClientID_: string
  RLClientID: number
  HashSum_RLClientID_: string
}

export interface ClientSearchAttributes {
  searchfield: string
  searchflags: string | number
  searchvalue: string
  page?: string
  instanceName?: string
}

export type ClientSearchResult = Array<{
  ID: number
  Full_Name: string
  LegalStatus: string
  BusinessTypeID: number
  RegDate: string
  ORG_IndustryID: number
  ClientType: number
  CardNumber: string
  Address2: string
  ORG_IndustrySubID: number
  Watched: number
  Black: number
  NodeID: number
  Insured: number
  HashSum_ClientID_: string
}>

export type ClientAddParams = {
  WHLSessionID: number
  HashSum_WHLSessionID_: string
  ClientType: number
  action: string
  Open_Day: string
  IND_Name: string
  IND_Surname: string
  IND_FatherName: string
  IND_DOB: string
  IND_BirthCountryID: number
  IND_BirthPlace: string
  ORG_IndustryID: number
  ORG_IndustrySubDetailID: number
  ORG_IndustrySubID: number
  BusinessTypeID: string
  IND_RegisteredBusinessID: number
  IND_StaticBusinessID: number
  LicenseCardNumber: string
  CountryID: string
  Country2ID: string
  CountryBusID: string
  IDCardTypeID: number
  IDCardIssuerID: number
  CardNumber: string
  OtherIDNumber: string
  CardNumberAlt: string
  OtherIDNumberAlt: string
  IDCardRegDate: string
  IDValidityDate: string
  IND_Sex: number
  Comment: string
  Address: string
  CityID: number
  Address2: string
  City2ID: number
  AddressBus: string
  ZoneBusID: number
  DistrictBusID: number
  CityBusID: number
  Phone: string
  CellPhone: string
  Email: string
  Email1: string
  CellPhoneValidateCode: number
  IND_FamilyMembers_Total: number
  FemaleFamily: number
  InvalidFamily: number
  IND_FamilyMembers_Bus: number
  IND_Children: number
  OldFamily: number
  IND_Dependants: number
  IND_Dependants_Female: number
  IND_Dependants_IDP_Total: number
  IND_Employed_Total: number
  IND_Employed_Female: number
  IND_Employed_IDP_Total: number
  ReferralID: number
  ReferralNote: string
  IND_MaritalStatusID: number
  IND_JobStatusID: number
  IND_EducationID: number
  IND_JobPositionID: number
  IND_ProfessionID: string
  IND_IDP: number
  IND_IncomeID: number
  IND_Resident: number
  IND_ExpencesID: number
  IND_NationalityID: number
  IND_DwellingID: number
  CitizenshipID: number
  Citizenship2ID: number
  IND_Insider: number
  IND_LanguagesID: number
  IND_LandID: number
  IND_HealthID: number
  ReligionID: number
  IND_EnglishKnowledge: number
  RaceID: number
  IND_ReadingSkills: number
  CasteID: number
  SMSPrefID: number
  EmailPrefID: number
  MCLEnabled: number
  SDAEnabled: number
  KYCValidityID: number
  StatusLevelID: number
  PEPFlag: number
  AMLStatusID: number
  AMLIndustryID: number
  AMLSuspiciousID: number
  AutoCoverPrefID: number
  ClientNotClientFlag: number
  SpecialNeedsFlag: number
  SMSSignFlag: number
  CField1: string
  CField2: string
  CField3: string
  CField4: string
  IND_Name_ALT: string
  IND_Surname_ALT: string
  IND_FatherName_ALT: string
  IND_BirthPlace_ALT: string
  Address_ALT: string
  Address2_ALT: string
  AddressBus_ALT: string
  IND_VehicleID: string
  NodeID: number
  IDCardIssuerTxt: string
  CodeVerifyPass: number
  SMSCodeSent: number
  CodeVerifyClicked: number
  ReqFieldGroupID: 1
  DynFieldData: string
}

export type ClientCheckDublicateParams = {
  typeid: number
  own_id: number
  serial: string
}

export type ClientCheckDublicateResponse = {
  ClientDupCheckResponse: {
    Result: number
    ErrorMessage: string
  }
}

export type ClientGetRequiredFiledsParams = {
  groupid: number
  typeid: number
}

export type ClientCheckReqFieldsParams = {
  ClientID: string | number
  HashSum_ClientID_: string | number
  ID: string | number
}

export type ClinetRelationsAddAttributes = {
  ID: string
  hash: string
  relatedClientID: number
  relatedClientHash: string
  relatedClientRelType: number
  clientRelType: number
  Node: number
  cfield: string
}

export type ClientRelationsDeleteAttributes = {
  ClientID: string
  clientHash: string
  RLClientID: number
  RelationID: number
  RelationClientHash: string
}

export enum ClinetRelationsPage {
  Add = 'relationadd',
  Delete = 'relationdelete',
}

export type ClientAddToBlackListAttributes = {
  ClientID: number
  HashSum_ClientID_: string
  Comment: string
}

export type ClientRemoveFromBlackListAttributes = {
  ClientID: number
  HashSum_ClientID_: string
}

export enum ClientBlacklistPage {
  Add = 'blacklist',
  Remove = 'blacklistundo',
}

export type ClientAddToWatchListAttributes = {
  ClientID: number
  HashSum_ClientID_: string
  Comment?: string
}

export type ClientRemoveFromWatchListAttributes = {
  ClientID: number
  HashSum_ClientID_: string
}

export enum ClientWatchlistPage {
  Add = 'watchlist',
  Remove = 'watchlistundo',
}

export type sendSMSParams = {
  ID: string | number
  hash: string
  smsText: string
  phoneNumber: string | number
}

export type SendNewPinSMSParams = Omit<sendSMSParams, 'smsText'>

export type ClientAddRemovePermissionParams = {
  ClientID: string | number
  HashSum_ClientID_: string
  ID: string | number
}

export type ValidatePinCodeParams = {
  ID: string | number
  hash: string
  code: string | number
}

export type ClinetAddIdDocParams = {
  ClientID: string | number
  hash: string
  IDCardTypeID: number | string
  IDCardIssuerID: number | string
  IDCardIssuerTxt: string
  IDNumber: string
  IssueDate: string
  ExpireDate: string
  DFDoc: boolean
  FileID: number
  HashSum_FileID_: string
}

export type ClinetEditIdDocParams = {
  ID: number | string
} & ClinetAddIdDocParams

export type ClientDeleteIdDocParams = {
  ClientID: string | number
  HashSum_ClientID_: string
  ID: string | number
}

export type ClientVerifySendSmsParams = {
  PersonalNo?: string | number
  CellPhone?: string | number
  ClientID?: number
  ClientHash?: string
  IDCardTypeID?: number
}

export type ClientVerifySMSVerifyParams = {
  Code?: string
} & ClientVerifySendSmsParams

export type ClientTagAddParams = {
  ClientID: number | string
  HashSum_ClientID_: string
  TagID: number | string
}

export type ClientDeleteTagParams = {
  ClientID: number | string
  HashSum_ClientID_: string
  ID: number | string
}
